import {ROLE_OWNER, ROLE_VALIDATOR} from '@app/utils/constants';
import {get} from 'lodash';
import React from 'react';
import {useSelector} from 'react-redux';
import OwnerDashboard from './OwnerDashboard';
import ValidatorDashboard from './ValidatorDashboard';

const Dashboard = () => {
  const currentUser = useSelector((state) => state.auth.currentUser);

  const renderDashboard = () => {
    const roles = get(currentUser, 'Roles', []);
    if (roles.includes(ROLE_OWNER)) {
      return <OwnerDashboard />;
    }
    if (roles.includes(ROLE_VALIDATOR)) {
      return <ValidatorDashboard />;
    }

    return <div>Generic Dashboard</div>;
  };

  return renderDashboard();
};

export default Dashboard;
